import type { State } from '../types';
import type User from '../../models/User';

export function isLoggedIn(state: State): boolean {
  return state.user.isLoggedIn;
}

export function isLoggingIn(state: State): boolean {
  return state.user.isLoggingIn;
}

export function isAddingUser(state: State): boolean {
  return state.user.isAddingUser;
}


export function getUser(state: State): ?User {
  return state.user.user;
}

export function getTempUser(state: State): ?User {
  return state.user.tempUser;
}

export function isSettingUpAuth(state: State): boolean {
  return state.user.isSettingUpAuth;
}

export function isUpdatingUser(state: State): boolean {
  return state.user.isUpdatingUser;
}

export function showIncorrectPasswordError(state: State): boolean {
  return state.user.showIncorrectPasswordError;
}

export function notificationsEnabled(state: State): boolean {
  return !!(state.user.user && state.user.user.notificationsEnabled);
}

export function showTouchIdNotSupportedError(state: State): boolean {
  return state.user.showTouchIdNotSupportedError;
}

export function showInvalidEmailError(state: State): boolean {
  return state.user.showInvalidEmailError;
}

export function showUnavailableEmailError(state: State): boolean {
  return state.user.showUnavailableEmailError;
}

export function showWeakPasswordError(state: State): boolean {
  return state.user.showWeakPasswordError;
}

export function isCreatingCustomer(state: State): boolean {
  return state.user.isCreatingCustomer;
}

export function isCreatingSubscription(state: State): boolean {
  return state.user.isCreatingSubscription;
}

export function isFetchingCoupon(state: State): boolean {
  return state.user.isFetchingCoupon;
}

export function showIncorrectCouponError(state: State): boolean {
  return state.user.showIncorrectCouponError;
}

export function showCouponSuccess(state: State): boolean {
  return state.user.showCouponSuccess;
}



// WEBPACK FOOTER //
// ./src/redux/user/selectors.js